import {useEffect, useMemo} from 'react';

import {useDatadogRum} from '../../../util/datadog/datadogRum';
import {
  useStatsigGateBackendLineConstruction,
  useStatsigGateBackendLineConstructionMultiMetric,
  useStatsigGateBackendLineConstructionSmoothing,
} from '../../../util/rampFeatureFlags';

export type BackendLineConstructionFlags = {
  canUseBackendLineConstruction: boolean;
  canUseBackendLineConstructionMultiMetric: boolean;
  canUseBackendLineConstructionSmoothing: boolean;
};

export const useBackendLineConstruction = (
  entityName: string
): BackendLineConstructionFlags => {
  const ddRum = useDatadogRum();
  const canUseBackendLineConstruction =
    useStatsigGateBackendLineConstruction(entityName);
  const canUseBackendLineConstructionMultiMetric =
    useStatsigGateBackendLineConstructionMultiMetric(entityName);
  const canUseBackendLineConstructionSmoothing =
    useStatsigGateBackendLineConstructionSmoothing(entityName);

  // track
  useEffect(() => {
    ddRum.addAction('Backend Line Construction: Panel Load', {
      useBackendLineConstruction: canUseBackendLineConstruction,
      useBackendLineConstructionMultiMetric:
        canUseBackendLineConstructionMultiMetric,
      useBackendLineConstructionSmoothing:
        canUseBackendLineConstructionSmoothing,
    });
  }, [
    canUseBackendLineConstruction,
    canUseBackendLineConstructionMultiMetric,
    canUseBackendLineConstructionSmoothing,
    ddRum,
  ]);

  return useMemo(
    () => ({
      canUseBackendLineConstruction,
      canUseBackendLineConstructionMultiMetric,
      canUseBackendLineConstructionSmoothing,
    }),
    [
      canUseBackendLineConstruction,
      canUseBackendLineConstructionMultiMetric,
      canUseBackendLineConstructionSmoothing,
    ]
  );
};
